// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"44":"bdd9f3b6","57":"bdd9f3b6","278":"bea8a336","297":"a27a6609","615":"bdd9f3b6"}[chunkId] + ".css";
};